<!--废弃-->
<template>
  <div id="ambulanceInfo" :class="{ fullscreenPage: isFullscreen }">
    <!--  <h2>我是点击某辆急救车 后进入的页面{{patientID}}</h2>-->
    <el-row
      :class="{ fullscreenVideoRow: isFullscreen }"
      type="flex"
      justify="space-between"
      class="videoRow"
    >
      <el-col :span="11.25">
        <!-- 心電圖與B超切換 -->
        <div v-show="clickStatus" class="changeBtnGroup">
          <!-- 心電圖與B超切換 -->
          <div class="changeBtn isActive">
            <img :src="currentShow" alt="">
            <img
              id="choosingBtn"
              src="@/assets/photos/aside-arrow-cleanMode-down.png"
              alt=""
              @click="isClick = !isClick"
            >
          </div>
          <!-- 心電圖與B超切換 -->
          <div
            class="changeBtn"
            :class="{ forChoosing: !isClick }"
            @click="changeBtnB"
          >
            <img src="@/assets/icons/cleanMode/b.png" alt="">
          </div>
          <!-- 心電圖與B超切換 -->
          <div
            class="changeBtn"
            :class="{ forChoosing: !isClick }"
            @click="changeBtnH"
          >
            <img src="@/assets/icons/cleanMode/heart.png" alt="">
          </div>
        </div>
        <div :class="{ 'diagram-bg': isFullscreen }" class="videoLeft">
          <electrocardiogram
            ref="diagram"
            :video-src="videoType2"
            :diogram-width="diagramWidth"
            :diogram-height="diagramHeight"
          />
        </div>
      </el-col>
      <el-col :span="13.5" class="car-video-demo">
        <div :class="{ carVideoBg: isFullscreen }" class="videoRight">
          <carVideo
            ref="video"
            :video-src="videoType1"
            :car-width="carWidth"
            :car-height="carHeight"
            :has-permission="hasPermission"
          />
          <!--这种属于直播类型的监控视频,只有 护士 || 信息科 需要请求权限-->
          <div v-show="isNurse">
            <!-- 如果不是护士的话,下面的代码直接不用显示了 -->
            <el-button v-if="!hasPermission" @click="getPermissionForLive">
              <!-- 如果是护士的话,再看看有没有权限 -->
              请求权限
            </el-button>
          </div>
        </div>
      </el-col>
      <!-- 请求成功弹窗 -->
      <my-dialog
        :dialog-carted="dialogSuccess"
        :width="390"
        title="提示"
        @confirmOk="dialogSuccess = false"
      >
        <template #content>
          <div>请求成功,请等待管理员通过</div>
        </template>
      </my-dialog>

      <!-- 请求失败弹窗 -->
      <my-dialog
        :dialog-carted="dialogError"
        :width="390"
        title="提示"
        @confirmOk="dialogError = false"
      >
        <template #content>
          <div>未知错误,请联系开发人员</div>
        </template>
      </my-dialog>
    </el-row>

    <el-row class="mapRow" :class="{ fullscreenRow: isFullscreen }">
      <el-col
        :span="11.25"
        :style="{ display: isShow }"
        :class="{ fullscreenMode: isFullscreen }"
      >
        <div class="ambulanceTableTitle">
          <span class="littleTitle">急救患者信息：</span>
        </div>
        <div class="ambulanceSituation-container">
          <div class="ambulanceSituation">
            <!-- // 第1行 -->
            <el-row>
              <el-col :span="3" :offset="1">
                <div>事例编号：</div>
              </el-col>
              <el-col :span="5" :offset="1">
                <div>{{ patientSituation.number }}</div>
              </el-col>
              <el-col :span="3" :offset="1">
                <div>受理时间：</div>
              </el-col>
              <el-col :span="8" :offset="1">
                <div>{{ patientSituation.formatTime }}</div>
              </el-col>
            </el-row>
            <!-- // 第二行 -->
            <el-row>
              <el-col :span="5" :offset="1">
                <div>阶段及最新上报时间：</div>
              </el-col>
              <el-col :span="16" :offset="1">
                <div>
                  {{ carStage[patientSituation.statu] }}
                  {{ patientSituation[carStageTime[patientSituation.statu]] }}分
                </div>
              </el-col>
            </el-row>
            <!-- // 第三行 -->
            <el-row>
              <el-col :span="2" :offset="1">
                <div>姓名：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patientSituation.name }}</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>性别：</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>{{ patientSituation.gender }}</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>年龄：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patientSituation.age }}岁</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>联系电话：</div>
              </el-col>
              <el-col :span="5" :offset="0">
                <div>{{ patientSituation.phoneNumber }}</div>
              </el-col>
            </el-row>
            <!-- // 第四行 -->
            <el-row>
              <el-col :span="2" :offset="1">
                <div>地址：</div>
              </el-col>
              <el-col :span="8" :offset="0">
                <div>{{ patientSituation.patientAddr }}</div>
              </el-col>
              <el-col :span="2" :offset="1">
                <div>主诉：</div>
              </el-col>
              <el-col :span="9" :offset="0">
                <div>{{ patientSituation.mainComplaint }}</div>
              </el-col>
            </el-row>
          </div>

          <div class="physicalSituation">
            <el-row>
              <el-col :span="2" :offset="1">
                <div>体温：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patientSituation.temperature }}℃</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>呼吸：</div>
              </el-col>
              <el-col :span="4" :offset="0">
                <div>{{ patientSituation.breath }}次/分</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>收缩压：</div>
              </el-col>
              <el-col :span="4" :offset="0">
                <div>{{ patientSituation.systolicPressure }}mmHg</div>
              </el-col>
              <el-col :span="2" :offset="0">
                <div>舒张压：</div>
              </el-col>
              <el-col :span="3" :offset="0">
                <div>{{ patientSituation.diastolicPressure }}mmHg</div>
              </el-col>
            </el-row>
          </div>

          <div class="patientSituation">
            <!-- <div>急救病人情况</div> -->
            <!-- // 第1行 -->
            <div class="patientSituationTitle">描述及诊断信息：</div>
            <!-- // 第2行 -->
            <el-row>
              <el-col :span="3" :offset="1">
                <div>语音记录：</div>
              </el-col>
              <el-col :span="4" :offset="1">
                <div v-if="patientSituation.wavList">共{{ getDescWav }}条</div>
              </el-col>
              <el-col :span="3" :offset="1">
                <div>初步诊断：</div>
              </el-col>
              <el-col :span="9" :offset="1">
                <div>{{ patientSituation.fistCheck }}</div>
              </el-col>
            </el-row>
            <!-- // 第3行 -->
            <el-row>
              <el-col :span="3" :offset="1">
                <div>描述：</div>
              </el-col>
              <el-col :span="18" :offset="1">
                <div>{{ patientSituation.details }}</div>
              </el-col>
            </el-row>
          </div>

          <div class="measures">
            <div class="measuresTitle">急救措施及用药：</div>
            <el-row>
              <el-col :span="3" :offset="1">
                <div>语音记录：</div>
              </el-col>
              <el-col :span="4" :offset="1">
                <div>共{{ getDrugWav }}条</div>
              </el-col>
              <el-col :span="2" :offset="1">
                <div>药剂：</div>
              </el-col>
              <el-col :span="9" :offset="1">
                <!-- <div :key="drug.id" v-for="drug in  patientSituation.costmedicalList">{{ drug.name }}  {{drug.number}};</div> -->
                <span
                  v-for="drug in patientSituation.costmedicalList"
                  :key="drug.id"
                >{{ drug.name }} &nbsp;&nbsp; {{ drug.number }}
                  {{ drug.unit }}&nbsp; &nbsp;{{ drug.rescueOrgan }};&nbsp; &nbsp;
                </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" :offset="1">
                <div>操作：</div>
              </el-col>
              <el-col :span="18" :offset="1">
                <div>{{ patientSituation.operationM }}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>

      <el-col :span="11.25" class="GMapRow">
        <div class="predicateTime">
          预计花费时间：
          <span>{{ leftTime || 0 }}分钟</span>
        </div>
        <live-map
          v-if="carID"
          :car-i-d="carID"
          :width="1430"
          :height="318"
          :is-fullscreen="isFullscreen"
          @getLeftTime="getLeftTime"
        />
      </el-col>
      <div class="fullscreen" @click="fullscreenBtn">
        <img src="@/assets/photos/fullscreen.png" alt="">
      </div>
      <div class="mic-button">
        <div class="two-refresh-button">
          <div class="refresh-button" @click="getStreamInfo1">
            <i class="el-icon-refresh "/>
            <span>刷新监护仪</span>
          </div>
          <div class="refresh-button" @click="getStreamInfo2">
            <i class="el-icon-refresh "/>
            <span>刷新监控</span>
          </div>
        </div>
        <el-switch
          v-model="isOpenMic"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="打开麦克风"
          inactive-text="关闭麦克风"
        />
      </div>
    </el-row>
  </div>
</template>

<script>
import LiveMap from "@components/MapContainer/LiveMap";
import CarVideo from "@components/stream/CarVideo";
import Electrocardiogram from "@components/stream/Electrocardiogram";
import MyDialog from "@components/customDialog/MyDialog.vue";
import screenfull from "screenfull";
import { getPermission } from "@api/user.js";
import { askPermission } from "@api/permission.js";
import { mapState } from "vuex";
import { getPushStreamToken, getStreamToken } from "@api/streamdata";
import { SrsRtcPublisherAsync } from "@utils/rtc";
import { srsRtcUrl } from "@utils/basic";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "ShowAmbulance",
  components: {
    LiveMap,
    CarVideo,
    Electrocardiogram,
    MyDialog
  },
  data() {
    return {
      isOpenMic: false, // 是否打开麦克风推流
      videoType2: "webrtc://", // 救护仪器
      videoType1: "webrtc://", // 摄像头和麦克风
      patientID: "", // 当前急救车接送/处理 的病人ID   //FIXME: 如果为空,则证明这个车车没有动! 没有出车!!  //有bug,不点击事件先,拿不到ID!!!!!!!!!!!!!!
      checkPermissionTimer: null, // 护士请求权限后, 循环判断是否有权限了
      isFullscreen: false,
      isIcon: true,
      clickStatus: 0, // 保留全屏按钮点击状态, 0非全屏
      isShow: "none", // 展示个人用户信息
      isNurse: false, // 判断是否为护士登陆
      hasPermission: false, // 总的判断是否有权限
      hasNursePermission: false, // 判断是否需要显示按钮
      carStage: {
        0: "收到报文",
        1: "出车时刻",
        2: "抵达现场",
        3: "患者上车",
        4: "到达医院"
      },
      carStageTime: {
        0: "formatTime",
        1: "turout_time",
        2: "arrived_time",
        3: "board_time",
        4: "done_time"
      },
      /*
      出车时刻       turout_time
      抵达现场       arrived_time
      患者上车       board_time
      到达医院       done_time
      */
      // 当前急救车id
      carID: "",
      isClick: false, // 是否被点击显示B超或者心电图
      currentShow:
        "https://seconddisk-1256408003.cos.ap-guangzhou.myqcloud.com/heart.png", // 默认显示的图标
      // 心电图值
      diagramWidth: 600,
      diagramHeight: 390,
      // 监控值
      carWidth: 800,
      carHeight: 390,
      checkPermissionForm: {
        userId: "",
        type: "checkUserPermission",
        checkAmbulanceId: "",
        // checkMedicalhistoryId: "" // 此病例ID 此处不需要传
      },
      askPerssionForm: {
        type: "checkLive",
        userId: "",
        hospitalId: "", // 怎么搞这个
        ambulanceId: this.carID,
        medicalhistoryId: "" // 病例的id
      },
      // 有些可能不需要
      patientSituation: [],
      // 总用时
      costTime: "",
      leftTime: "", // 急救车返程时间
      isSounds: false,
      isSoundsUrl:
        "https://seconddisk-1256408003.cos.ap-guangzhou.myqcloud.com/non-mute.png",
      isVolume: false,
      isvolumeUrl:
        "https://seconddisk-1256408003.cos.ap-guangzhou.myqcloud.com/non-mute.png",
      dialogSuccess: false,
      dialogError: false,
      publisher: null,
      fullscreenLoading: false,
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      currentList: "currentList",
      hospitalID: "hospitalID",
      userInfo: "userInfo",
    }),
    getDescWav() {
      const { wavList } = this.patientSituation;
      if (!wavList) {
        return 0;
      }
      const items = wavList.map((e) => {
        return e.fromW === "描述语音";
      });
      return items.length;
    },
    getDrugWav() {
      const { wavList } = this.patientSituation;
      if (!wavList) {
        return 0;
      }
      const items = wavList.map((e) => {
        return e.fromW === "急救语音";
      });
      return items.length;
    }
  },
  watch: {
    currentList: {
      handler(val) {
        this.patientSituation = val.find(mission => {
          return mission.ambulanceId === this.carID;
        }) || {};
      }
    },
    isOpenMic: {
      handler(val) {
        if (val) {
          this.startPushAudio();
        } else {
          this.publisher && this.publisher.close();
        }
      },
      immediate: true
    }
  },
  beforeUnmount() {
    clearInterval(this.checkPermissionTimer);
    this.checkPermissionTimer = null;
    if (this.publisher) {
      this.publisher.close();
    }
  },
  mounted() {
    this.detectFullscreen();
    this.getBasicData();
    this.checkPermission();
    // 刷新视频的同时, 刷新音频
    this.getStreamInfo();
  },
  methods: {
    // 推流麦克风
    startPushAudio() {
      getPushStreamToken(this.carID).then(({ code, token, car_number, audio_can }) => {
        if (code !== 200) return;
        if (audio_can !== 1) {
          this.isOpenMic = false;
          throw Error("麦克风只能同时被一个用户使用, 当前有其他用户正在使用, 不允许使用, 请稍后再试!");
        }
        this.publisher = new SrsRtcPublisherAsync();
        const url = srsRtcUrl + `${car_number}/${car_number}-audio?token=${token}`;
        this.publisher.publish(url)
          .then(() => {
            console.log("ee");
          })
          .catch(e => {
            console.log("000000000000000000000000");
            console.log(e);
          });
      }).catch(e =>
        showWindowMessage(3, e, this)
      );
    },
    // 拉取webrtc视频流 || 进来的时候 (两个都拉)
    getStreamInfo() {
      // 判断是否有打开麦克风, 有的话, 也要重新连接
      if (this.isOpenMic) {
        this.publisher && this.publisher.close();
        this.startPushAudio();
      }
      getStreamToken(this.carID).then(({ code, data }) => {
        if (code === 200 || code === 405) {
          const type1 = data.find(e => {
            return e.type === 1;
          });
          const type2 = data.find(e => {
            return e.type === 2;
          });
          if (type1) {
            this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}&time=${Date.now()}`; // 摄像头和麦克风
          }
          if (type2) {
            this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}&time=${Date.now()}`; // 救护仪器
          }
        } else {
          this.videoType1 = srsRtcUrl + "";
          this.videoType2 = srsRtcUrl + "";
        }
      });
    },
    // 拉取监护仪
    getStreamInfo1() {
      // 判断是否有打开麦克风, 有的话, 也要重新连接
      getStreamToken(this.carID).then(({ code, data }) => {
        if (code === 200 || code === 405) {
          const type2 = data.find(e => {
            return e.type === 2;
          });
          if (type2) {
            this.videoType2 = srsRtcUrl + `${type2.app}/${type2.stream}?token=${type2.token}&time=${Date.now()}`; // 救护仪器
          }
        } else {
          this.videoType2 = srsRtcUrl + "";
        }
      });
    },
    // 拉取监控
    getStreamInfo2() {
      // 判断是否有打开麦克风, 有的话, 也要重新连接
      if (this.isOpenMic) {
        this.publisher && this.publisher.close();
        this.startPushAudio();
      }
      getStreamToken(this.carID).then(({ code, data }) => {
        if (code === 200 || code === 405) {
          const type1 = data.find(e => {
            return e.type === 1;
          });
          if (type1) {
            this.videoType1 = srsRtcUrl + `${type1.app}/${type1.stream}?token=${type1.token}&time=${Date.now()}`; // 摄像头和麦克风
          }
        } else {
          this.videoType1 = srsRtcUrl + "";
        }
      });
    },
    getLeftTime(leftTime) {
      this.leftTime = Math.round(leftTime / 60);
    },
    getBasicData() {
      const { id: carID } = this.$route.params;
      this.carID = carID * 1;
      const { id: userId } = this.userInfo;
      this.checkPermissionForm = {
        userId,
        checkAmbulanceId: carID,
        type: "checkUserPermission",
      };
      // /* 以下的代码是请求出车的急救车列表,但是具体实践过程中,可能会只有一辆急救车
      const item = this.currentList.find(e => {
        return e.ambulanceId === carID * 1;
      });

      if (!item) {
        // fixme: // 证明没有发车, 没有那车那怎么半呢
      }
      this.patientID = item?.id;
      this.askPerssionForm = {
        type: "checkLive",
        hospitalId: this.hospitalID,
        ambulanceId: carID,
        medicalhistoryId: item?.id,
        userId
      };
    },

    detectFullscreen() {
      //  监听全屏事件触发  总是有些扑街仔不按套路出牌
      [
        "fullscreenchange",
        "webkitfullscreenchange",
        "mozfullscreenchange"
      ].forEach((item, index) => {
        window.addEventListener(item, () => this.fullscreenchange());
      });
    },
    // 判断全屏情况，增删对应的class
    fullscreenBtn() {
      const element = document.getElementById("ambulanceInfo");
      if (this.clickStatus === 0) {
        this.clickStatus = 1;
        if (screenfull.isEnabled) {
          screenfull.request(element);
          // 請求病人相關數據
          this.isShow = "block";
          this.isFullscreen = true;
          // 修改元素寬高
          // 首先是心電圖 然後是監控
          this.$refs.diagram.width = "720";
          this.$refs.video.width = "960";
          this.$refs.diagram.height = "540";
          this.$refs.video.height = "540";
        }
      } else {
        if (screenfull.isEnabled) {
          screenfull.exit();
          this.isFullscreen = false;
          this.isShow = "none";
          this.clickStatus = 0;
          // 退出後要復原
          // 首先是心電圖,然後是監控
          this.$refs.diagram.width = "600";
          this.$refs.video.width = "800";
          this.$refs.diagram.height = "390";
          this.$refs.video.height = "390";
        }
      }
    },
    //  监听全屏事件触发  总是有些扑街仔不按套路出牌
    fullscreenchange() {
      const isFullScreen =
        document.fullScreen ||
        document.mozFullScreen ||
        document.webkitIsFullScreen;
      if (isFullScreen) {
        //  进入全屏
        this.clickStatus = 1;
        this.isShow = "block";
        this.isFullscreen = true;
        this.isIcon = false;
        console.log("进入全屏");
      } else {
        //  退出全屏
        this.isShow = "none";
        this.isFullscreen = false;
        this.isIcon = true;
        this.clickStatus = 0;
        // 退出後要復原
        // 首先是心電圖,然後是監控
        this.$refs.diagram.width = "600";
        this.$refs.video.width = "800";
        this.$refs.diagram.height = "390";
        this.$refs.video.height = "390";
      }
    },
    checkPermission() {
      this.isNurse = (this.userInfo.loginUserId === 3);
      if (!this.isNurse) { // 不是护士之类的直接就能看, 护士的话, 需要申请权限
        this.hasPermission = true;
        return;
      }
      // 查询当前用户是否已经有 监控视频权限
      getPermission(this.checkPermissionForm)
        .then(({ code }) => {
          /*
          * 等于1 即是有权限 有权限,可以看 可能护士已经申请过了,并且已经通过了
          * */
          this.hasPermission = code === "1";
          if (this.checkPermissionTimer && code === "1") {
            clearInterval(this.checkPermissionTimer);
            this.checkPermissionTimer = null;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    async getPermissionForLive() {
      // 如果护士没有权限,则去请求权限
      const res = await askPermission(this.askPerssionForm);
      if (res.code == 1) {
        this.dialogSuccess = true;
      } else {
        this.dialogError = true;
      }
      // 在这之后, 循环请求是否已经拥有权限
      this.checkPermissionTimer = window.setInterval(() => {
        this.checkPermission();
        console.log("检查获得没");
        // TODO: 按理来说, 应该就可以了
      }, 5000);
    },
    changeBtnB() {
      // 切换B超
      // FIXME: 後期要真的可以切換
      this.currentShow = "https://seconddisk-1256408003.cos.ap-guangzhou.myqcloud.com/b.png";
      this.isClick = false;
    },
    changeBtnH() {
      // 切换心电图
      this.currentShow = "https://seconddisk-1256408003.cos.ap-guangzhou.myqcloud.com/heart.png";
      this.isClick = false;
    },
  },
};
</script>

<style scoped lang='scss'>
@import "../../assets/css/showAmbulance.css";

.two-refresh-button {
  display: flex;
  justify-content: space-between;
}

#panel {
  height: 400px;
  top: 500px;
}

.fullscreen {
  position: absolute;
  width: 50px;
  height: 50px;
  right: 10px;
  bottom: 5px;
  background: #efefef;
  text-align: center;
  line-height: 50px;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
  cursor: pointer;

  img {
    width: 31px;
    height: 31px;
    vertical-align: middle;
  }
}

// 无权限的时候显示的照片
.normalStatus {
  width: 640px;
  height: 360px;
}

.fullStatus {
  width: 960px;
  height: 540px;
}

.fullscreenPage {
  padding-top: 0 !important;
  width: 1875px !important;
  margin: 0 auto !important;
  background: #333333 !important;
}

.predicateTime {
  background: #efefef;
  bottom: 4px;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
  color: #666666;
  font-size: 22px;
  font-weight: bold;
  height: 50px;
  left: 10px;
  line-height: 50px;
  position: absolute;
  text-align: center;
  vertical-align: bottom;
  width: 280px;
  z-index: 161;
}

#ambulanceInfo {
  margin: 0 auto;
  padding-top: 20px;
  width: 1430px;

  .diagram-bg {
    background: #666666;
    height: 540px;
    position: relative;
    width: 900px;

    > div {
      margin: 0 auto;
    }
  }

  .carVideoBg {
    div {
      margin-left: 0;
    }

    width: 960px;
    height: 540px;
    background: #666666;
    margin-left: 10px;
  }
}

.electrocardiogram {
  width: 482px;
  height: 360px;
}

.mapRow {
  padding-top: 40px;
  margin: 0 auto;
}

.fullscreenRow {
  width: 1875px;
  padding-top: 7px;
}

.fullscreenVideoRow {
  width: 1875px;
  margin: 0 auto;
  display: block;
}

.car-video-demo {
  position: relative;

  .el-button {
    position: absolute;
    top: 45%;
    right: 45%;
    bottom: 45%;
    height: 50px;
    background: #0c618b77;
    box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);
    border-radius: 6px;
    font-size: 18px;
    font-weight: bold;
    color: #efefef;
  }
}

.ambulanceTableTitle {
  width: 160px;
  height: 40px;
  background: #efefef;
  box-shadow: 0 0 6px 0 rgba(6, 53, 76, 0.5);

  .littleTitle {
    display: inline-block;
    padding-left: 10px;
    line-height: 40px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #333333;
  }
}

.ambulanceSituation {
  width: 815px;
  background: #f4f4f4;
  border-radius: 10px;
  margin-left: 43px;
  margin-top: 30px;
  line-height: 2;
}

.physicalSituation {
  width: 815px;
  background: #f4f4f4;
  border-radius: 10px;
  margin-left: 43px;
  margin-top: 20px;
  line-height: 2;
}

.patientSituation {
  width: 815px;
  background: #f4f4f4;
  border-radius: 10px;
  margin-left: 43px;
  margin-top: 20px;
  line-height: 2;

  .patientSituationTitle {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-left: 10px;
  }
}

.measures {
  width: 815px;
  background: #f4f4f4;
  border-radius: 10px;
  margin-left: 43px;
  margin-top: 20px;
  line-height: 2;

  .measuresTitle {
    font-size: 18px;

    font-weight: bold;
    color: #333333;
    margin-left: 10px;
  }
}

.GMapRow {
  position: relative;
}

.fullscreenMode {
  width: 900px !important;
  height: 530px;
  overflow-y: scroll;
  background: #e4e1e1;
}

.changeBtnGroup {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;

  .changeBtn {
    width: 80px;
    height: 70px;
    cursor: pointer;
    margin-bottom: 0;

    background: #efefef;
    text-align: center;

    img {
      width: 50px;
      height: 50px;
      margin-top: 10px;
    }
  }
}

.changeBtn:hover {
  background-color: #e4e1e1;
}

.el-divider--horizontal {
  width: 800px;
  background: #06354c;
  opacity: 0.6;
  margin: 0 0 0 50px;
}

// 按钮组相关操作
.forChoosing {
  background-color: #e4e1e1;
  display: none;
}

.isActive {
  position: relative;
}

#choosingBtn {
  display: inline-block;
  height: 6px;
  padding: 10px 1px;
  position: absolute;
  right: 1px;
  top: 38%;
  transform: translateY(-50%);
  width: 12px;
}

.videoLeft,
.videoRight {
  position: relative;
}

.imageRight {
  position: absolute;
  left: 15px;
  bottom: 11px;
  width: 28px;
  height: 25px;
  cursor: pointer;
}

.imageLeft {
  position: absolute;
  left: 15px;
  bottom: 11px;
  width: 28px;
  height: 25px;
  cursor: pointer;
}

.leftVolumeIcon {
  width: 600px;
  height: 48px;
  background: #e4e1e1;
}

.rightVolumeIcon {
  width: 800px;
  height: 48px;
  background: #e4e1e1;
}

.mic-button {
  position: absolute;
  right: -50px;
  bottom: -50px;

  .refresh-button {
    cursor: pointer;

    i {
      font-size: 16px;
    }
  }
}
</style>
<style>
.is-message-box {
  justify-content: center;
}
</style>
